/* The Sleep Co fabric samples page.
 * One shared sample pack for every tsc-fs-collection section, plus the pinned pack bar.
 * Cart format matches the previous picker: one line of the sample product,
 * quantity = number of swatches, properties "Selected fabric samples" and "_fabric_samples".
 */
(function () {
  if (window.TSCFS) return;

  var MAX = 8;
  var STORE_KEY = 'tscfs_pack_v1';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cssUrl(u) { return 'url("' + String(u).replace(/"/g, '\\"') + '")'; }
  function shade(hex, p) {
    var n = parseInt(String(hex).replace('#', ''), 16);
    if (isNaN(n)) return hex;
    var r = n >> 16, g = (n >> 8) & 255, b = n & 255, t = p < 0 ? 0 : 255, a = Math.abs(p);
    r = Math.round(r + (t - r) * a); g = Math.round(g + (t - g) * a); b = Math.round(b + (t - b) * a);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }
  function swatchBg(c) {
    if (c.img) return cssUrl(c.img) + ' center/cover no-repeat';
    if (c.hex) return 'radial-gradient(120% 90% at 30% 18%, ' + shade(c.hex, 0.22) + ' 0%, ' + c.hex + ' 48%, ' + shade(c.hex, -0.3) + ' 100%)';
    return '';
  }

  /* ---------- Pack store ---------- */
  var Pack = {
    items: [],
    subs: [],
    load: function () {
      try { var raw = sessionStorage.getItem(STORE_KEY); this.items = raw ? JSON.parse(raw) : []; }
      catch (e) { this.items = []; }
      if (!Array.isArray(this.items)) this.items = [];
      this.items = this.items.slice(0, MAX);
    },
    save: function () { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(this.items)); } catch (e) {} },
    has: function (id) { return this.items.some(function (i) { return i.id === id; }); },
    toggle: function (item) {
      var idx = -1;
      this.items.forEach(function (i, n) { if (i.id === item.id) idx = n; });
      var result;
      if (idx > -1) { this.items.splice(idx, 1); result = 'removed'; }
      else if (this.items.length >= MAX) { result = 'full'; }
      else { this.items.push(item); result = 'added'; }
      if (result !== 'full') this.save();
      this.emit(result, item);
      return result;
    },
    remove: function (id) {
      this.items = this.items.filter(function (i) { return i.id !== id; });
      this.save(); this.emit('removed');
    },
    clear: function () { this.items = []; this.save(); this.emit('cleared'); },
    on: function (fn) { this.subs.push(fn); },
    emit: function (type, item) {
      var self = this;
      this.subs.forEach(function (fn) { try { fn(type, item, self.items); } catch (e) { console.error(e); } });
      try {
        window.dispatchEvent(new CustomEvent('sleepco:sample-pack-updated', {
          detail: { count: self.items.length, limit: MAX, selections: self.items.slice() }
        }));
      } catch (e) {}
    }
  };
  Pack.load();

  /* ---------- Collection widget ---------- */
  function mountCollection(root) {
    if (!root || root.dataset.tscfsMounted === '1') return;
    var dataEl = root.querySelector('script[data-tscfs-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[tscfs] bad data', e); return; }
    if (!data.ranges || !data.ranges.length) return;
    root.dataset.tscfsMounted = '1';

    var kind = data.kind;
    var st = { r: 0, c: 0 };
    var rail = root.querySelector('[data-tscfs-rail]');
    var stage = root.querySelector('[data-tscfs-stage]');
    var info = root.querySelector('[data-tscfs-info]');
    var wall = root.querySelector('[data-tscfs-wall]');
    var isNarrow = window.matchMedia('(max-width: 1000px)');

    function idFor(r, c) { return kind + '|' + r.name + '|' + c.name; }
    function itemFor(r, c) {
      return {
        id: idFor(r, c),
        fabric: r.pack_fabric || r.name,
        color: c.name,
        image: c.img || '',
        hex: c.hex || '',
        label: (r.pack_label || r.name) + ' ' + c.name
      };
    }
    function flash(result, r, c) {
      window.dispatchEvent(new CustomEvent('tscfs:message', {
        detail: result === 'full' ? { text: 'Your pack is full at eight. Remove one to add another.' }
          : result === 'added' ? { text: 'Added ' + (r.pack_label || r.name) + ' ' + c.name } : { text: '' }
      }));
    }

    function drawRail() {
      rail.innerHTML = '';
      data.ranges.forEach(function (r, i) {
        var t = document.createElement('button');
        t.type = 'button'; t.className = 'tscfs-tab'; t.setAttribute('role', 'tab');
        t.setAttribute('aria-selected', i === st.r ? 'true' : 'false');
        t.tabIndex = i === st.r ? 0 : -1;
        t.innerHTML = esc(r.name) + '<small>' + r.colours.length + ' ' + esc(data.tab_unit || 'colours') + '</small>';
        t.addEventListener('click', function () { select(i, 0, true); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : data.ranges.length - 1)) % data.ranges.length;
          select(n, 0, true);
          rail.children[n].focus();
        });
        rail.appendChild(t);
      });
    }

    function drawWall() {
      var r = data.ranges[st.r];
      wall.innerHTML = '';
      r.colours.forEach(function (c, i) {
        var on = Pack.has(idFor(r, c));
        var t = document.createElement('div');
        t.className = 'tscfs-tile' + (i === st.c ? ' is-current' : '');
        var stock = (kind === 'quick_ship' && c.count > 0)
          ? '<span class="tscfs-tile__stock">' + (c.count === 1 ? '1 bed' : c.count + ' beds') + '</span>' : '';
        t.innerHTML =
          '<button type="button" class="tscfs-tile__btn" aria-label="' + (c.vid ? 'Watch ' : 'View ') + esc(r.name + ' ' + c.name) + '">' +
            '<span class="tscfs-tile__img" style="background:' + esc(swatchBg(c)) + '">' +
              (c.vid ? '<span class="tscfs-tile__play" aria-hidden="true">&#9654;</span>' : '') + stock +
            '</span>' +
            '<span class="tscfs-tile__name"><b>' + esc(c.name) + '</b>' + esc(r.name) + '</span>' +
          '</button>' +
          '<button type="button" class="tscfs-add' + (on ? ' is-in' : '') + '" aria-pressed="' + on + '" aria-label="' +
            (on ? 'Remove ' : 'Add ') + esc(r.name + ' ' + c.name) + (on ? ' from' : ' to') + ' your sample pack">' + (on ? '&#10003;' : '+') + '</button>';
        t.children[0].addEventListener('click', function () {
          select(st.r, i, true);
          if (isNarrow.matches) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        t.children[1].addEventListener('click', function () { flash(Pack.toggle(itemFor(r, c)), r, c); });
        wall.appendChild(t);
      });
    }

    function drawStage(play) {
      var r = data.ranges[st.r], c = r.colours[st.c];
      var on = Pack.has(idFor(r, c)), full = !on && Pack.items.length >= MAX;
      stage.style.background = swatchBg(c);
      var html = '';
      if (c.vid) {
        html += '<video muted loop playsinline autoplay preload="metadata"' + (c.img ? ' poster="' + esc(c.img) + '"' : '') +
          ' src="' + esc(c.vid) + '" aria-label="Film of ' + esc(r.name + ' ' + c.name) + '"></video>';
      }
      if (kind === 'quick_ship' && c.count > 0) html += '<span class="tscfs-stage__stock">In stock</span>';
      html += '<span class="tscfs-stage__cap"><small>' + esc(r.name) + '</small>' + esc(c.name) + '</span>';
      stage.innerHTML = html;
      var v = stage.querySelector('video');
      if (v && play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

      var extra = '';
      if (r.spec && r.spec.length) {
        extra += '<dl class="tscfs-spec">' + r.spec.map(function (s) {
          return '<div><dt>' + esc(s[0]) + '</dt><dd>' + esc(s[1]) + '</dd></div>';
        }).join('') + '</dl>';
      }
      if (data.price_note) extra += '<p class="tscfs-info__count">' + data.price_note + '</p>';
      else if (kind === 'quick_ship') extra += '<p class="tscfs-info__count">' + (c.count === 1 ? '1 bed' : c.count + ' beds') + ' built and ready to deliver</p>';
      else extra += '<p class="tscfs-info__count">' + r.colours.length + ' colourways in this range</p>';

      var second = '';
      if (kind === 'quick_ship' && c.url) second = '<a class="tscfs-link" href="' + esc(c.url) + '">' + (c.count === 1 ? 'See the bed in ' : 'See beds in ') + esc(c.name) + '</a>';
      else if (data.secondary_url) second = '<a class="tscfs-link" href="' + esc(data.secondary_url) + '">' + esc(data.secondary_label || 'Find out more') + '</a>';

      info.innerHTML =
        '<p class="tscfs-info__family">' + esc(r.family || data.family_label || '') + '</p>' +
        '<h3 class="tscfs-info__name">' + esc(r.name) + '</h3>' +
        (r.desc ? '<p class="tscfs-info__desc">' + esc(r.desc) + '</p>' : '') + extra +
        '<div class="tscfs-info__actions"><button type="button" class="tscfs-btn' + (on ? ' is-in' : '') + '"' + (full ? ' disabled' : '') + '>' +
          (on ? 'Remove ' + esc(c.name) + ' from pack' : full ? 'Sample pack full' : 'Add ' + esc(c.name) + ' to sample pack') +
        '</button>' + second + '</div>';
      info.querySelector('.tscfs-btn').addEventListener('click', function () { flash(Pack.toggle(itemFor(r, c)), r, c); });
    }

    function select(ri, ci, play) {
      var changedRange = ri !== st.r;
      st.r = ri; st.c = ci;
      if (changedRange || !rail.children.length) drawRail();
      else Array.prototype.forEach.call(rail.children, function (t, n) {
        t.setAttribute('aria-selected', n === ri ? 'true' : 'false'); t.tabIndex = n === ri ? 0 : -1;
      });
      drawWall(); drawStage(play);
    }

    drawRail(); drawWall(); drawStage(false);
    Pack.on(function () { drawWall(); drawStage(false); });

    /* Deep link: ?range=Velvet&colour=Olive (optionally &collection=quick_ship) */
    try {
      var q = new URLSearchParams(window.location.search);
      var wantRange = (q.get('range') || '').toLowerCase(), wantColour = (q.get('colour') || q.get('color') || '').toLowerCase();
      var wantKind = (q.get('collection') || '').toLowerCase();
      if (wantRange && (!wantKind || wantKind === kind)) {
        data.ranges.forEach(function (r, ri) {
          if (r.name.toLowerCase() !== wantRange) return;
          var ci = 0;
          r.colours.forEach(function (c, n) { if (c.name.toLowerCase() === wantColour) ci = n; });
          select(ri, ci, false);
          setTimeout(function () { root.scrollIntoView({ block: 'start' }); }, 50);
        });
      }
    } catch (e) {}
  }

  /* ---------- Cart ---------- */
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  /* Same flow as the theme's product-form.js: ask the cart drawer which sections it renders,
     fetch them, open the drawer and let it update itself (this also updates the basket icon count). */
  async function refreshCartUI(apiResponse) {
    var drawer = document.querySelector('cart-drawer');
    var cartUrl = (window.routes && window.routes.cart_url) || root() + 'cart';
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') {
      window.location = cartUrl;
      return true;
    }
    try {
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      var sections = {};
      if (ids) {
        var res = await fetch(root() + '?sections=' + encodeURIComponent(ids) + '&_tscfs=' + Date.now(),
          { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
        if (res.ok) sections = await res.json();
      }
      var merged = Object.assign({}, apiResponse || {}, { sections: Object.assign({}, (apiResponse && apiResponse.sections) || {}, sections) });
      drawer.classList.remove('translate-x-full');
      var overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) overlay.classList.remove('opacity-0', 'invisible');
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: merged }); } catch (e) {}
      }
      drawer.renderContents(merged);
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'tscfs', response: merged } })); } catch (e) {}
      return true;
    } catch (e) {
      console.warn('[tscfs] cart drawer refresh failed', e);
      window.location = cartUrl;
      return true;
    }
  }

  async function addPackToCart(cfg) {
    var label = cfg.property_label || 'Selected fabric samples';
    var selections = Pack.items.map(function (i) { return { fabric: i.fabric, color: i.color, image: i.image || '' }; });
    if (!selections.length) throw new Error('Your pack is empty.');

    var cartRes = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!cartRes.ok) throw new Error('Could not read your basket.');
    var cart = await cartRes.json();

    function props(list) {
      var p = {};
      p[label] = list.map(function (s) { return s.fabric + ' \u2013 ' + s.color; }).join(', ');
      p._fabric_samples = JSON.stringify(list);
      return p;
    }

    var existing = (cart.items || []).find(function (item) {
      if (String(item.variant_id) !== String(cfg.variant_id)) return false;
      var pr = item.properties || {};
      return Boolean(pr._fabric_samples || pr[label]);
    });

    var res;
    if (existing) {
      var prev = [];
      try { prev = JSON.parse((existing.properties || {})._fabric_samples || '[]'); } catch (e) {}
      var merged = Array.isArray(prev) ? prev.slice() : [];
      selections.forEach(function (s) {
        if (!merged.some(function (m) { return m.fabric === s.fabric && m.color === s.color; })) merged.push(s);
      });
      if (merged.length > MAX) throw new Error('A sample pack holds up to eight fabrics, and your basket already has ' + prev.length + '. Remove some before adding more.');
      res = await fetch(root() + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: existing.key, quantity: merged.length, properties: props(merged) })
      });
    } else {
      res = await fetch(root() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: cfg.variant_id, quantity: selections.length, properties: props(selections) }] })
      });
    }
    var json = null;
    try { json = await res.json(); } catch (e) {}
    if (!res.ok || (json && (json.status || json.errors))) {
      throw new Error((json && (json.description || json.message)) || 'Could not add your samples. Please try again.');
    }
    return json;
  }

  /* ---------- Pack bar ---------- */
  function mountPackBar(el) {
    if (!el || el.dataset.tscfsMounted === '1') return;
    el.dataset.tscfsMounted = '1';
    var cfg = {};
    try { cfg = JSON.parse(el.querySelector('script[data-tscfs-pack]').textContent); } catch (e) {}
    var price = Number(cfg.price_pence || 50) / 100;
    var slots = el.querySelector('[data-tscfs-slots]');
    var count = el.querySelector('[data-tscfs-count]');
    var drawer = el.querySelector('[data-tscfs-drawer]');
    var toggle = el.querySelector('[data-tscfs-toggle]');
    var msg = el.querySelector('[data-tscfs-msg]');
    var cta = el.querySelector('[data-tscfs-cta]');
    var busy = false, msgTimer;

    document.body.classList.add('tscfs-has-pack');

    function say(html, keep) {
      msg.innerHTML = html || '';
      clearTimeout(msgTimer);
      if (html && !keep) msgTimer = setTimeout(function () { msg.innerHTML = ''; }, 3200);
    }
    function money(n) { return '\u00a3' + n.toFixed(2); }

    function render() {
      var items = Pack.items, n = items.length;
      count.textContent = n + ' of ' + MAX;
      slots.innerHTML = '';
      for (var i = 0; i < MAX; i++) {
        var s = document.createElement('span');
        s.className = 'tscfs-pack__slot' + (items[i] ? ' is-full' : '');
        if (items[i]) s.style.background = swatchBg({ img: items[i].image, hex: items[i].hex });
        slots.appendChild(s);
      }
      if (!busy) {
        cta.disabled = n === 0;
        cta.textContent = n === 0 ? (cfg.empty_label || 'Choose a swatch') : 'Add ' + n + ' to basket, ' + money(n * price);
      }
      drawer.innerHTML = n === 0
        ? '<p class="tscfs-pack__empty">' + esc(cfg.empty_text || 'Your pack is empty. Tap + on any colour to add it.') + '</p>'
        : '<ul>' + items.map(function (it) {
            return '<li><i style="background:' + esc(swatchBg({ img: it.image, hex: it.hex })) + '"></i>' + esc(it.label) +
              '<button type="button" data-rm="' + esc(it.id) + '" aria-label="Remove ' + esc(it.label) + '">&times;</button></li>';
          }).join('') + '</ul>';
      drawer.querySelectorAll('[data-rm]').forEach(function (b) {
        b.addEventListener('click', function () { Pack.remove(b.getAttribute('data-rm')); });
      });
    }

    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Hide pack' : 'View pack';
    });

    cta.addEventListener('click', async function () {
      if (busy || !Pack.items.length) return;
      busy = true; cta.disabled = true; cta.textContent = 'Adding\u2026';
      try {
        var resp = await addPackToCart(cfg);
        Pack.clear();
        var opened = await refreshCartUI(resp);
        if (!opened) say('Added to your basket. <a href="' + root() + 'cart">View basket</a>', true);
      } catch (e) {
        say(esc(e.message || 'Something went wrong. Please try again.'), true);
      } finally {
        busy = false; render();
      }
    });

    window.addEventListener('tscfs:message', function (e) { say(esc((e.detail && e.detail.text) || '')); });
    Pack.on(render);
    render();
  }

  function mountAll(scope) {
    (scope || document).querySelectorAll('[data-tscfs-collection]').forEach(mountCollection);
    (scope || document).querySelectorAll('[data-tscfs-packbar]').forEach(mountPackBar);
  }

  window.TSCFS = { Pack: Pack, mountAll: mountAll, MAX: MAX };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  else mountAll();

  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
})();
